import t from 'react-translate';
import { useContext } from 'react';
import { css } from '@emotion/react';
import { config } from '@config/pendo.config.json';
import { SessionTypes } from 'redux/schemas/models/live-event';

import { Button } from 'react-bootstrap';
import MentoringProgramContext from 'athena/components/mentoring-program/context';
import {
  ALL_INTEGRATION_TYPES,
  translationIntegrationKeys,
} from 'redux/schemas/models/mentoring-program-sessions';

const styles = css`
  &:focus {
    box-shadow: none;
    text-decoration: none;
  }
`;

type ConnectAccountButtonProps = {
  type: SessionTypes | typeof ALL_INTEGRATION_TYPES;
  isExpired?: boolean;
  onClick: () => void;
};

const ConnectAccountButton = (props: ConnectAccountButtonProps) => {
  const { type, isExpired, onClick } = props;
  const isExpiredKey = isExpired ? '_EXPIRED' : '';
  const translationKey = `${translationIntegrationKeys[type]}${isExpiredKey}`;
  const translations = t.MENTORING_PROGRAMS.PARTICIPANT_HOME.PLAN_SESSION_FLYOUT.VIRTUAL_MEETING.CONNECT;
  const connectAccountText = translations[translationKey]();

  const { mentoringProgram } = useContext(MentoringProgramContext);
  const dataQa = config.pendo.athena.mentorshipProgram.participantHome.sessions.planSessionFlyout.virtualMeeting.connectAccount;
  const dataQaId = `${dataQa}_${mentoringProgram?.id}`;

  return (
    <Button
      css={styles}
      onClick={onClick}
      variant='link'
      className='semi-bold'
      data-qa={dataQa}
      data-qa-id={dataQaId}
      aria-label={connectAccountText}
    >
      {connectAccountText}
    </Button>
  );
};

export default ConnectAccountButton;
